import { render, staticRenderFns } from "./PrimaryChip.vue?vue&type=template&id=2e3faf88&"
import script from "./PrimaryChip.vue?vue&type=script&lang=ts&"
export * from "./PrimaryChip.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports